import { ActionReducer } from '@ngrx/store';
import { ApplicationList } from '../../model/application/application-list.model';
import * as enabledApplications from '../../actions/application-list.actions';

export const enabledApplicationList: ActionReducer<ApplicationList>
    = (state: ApplicationList = null, action: enabledApplications.Actions) => {
    switch (action.type) {
        case enabledApplications.LOAD_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/enabled-applicaton/enabled-application-list.reducer.ts